import styled, { css } from 'styled-components';
import { body2Bold, caption1 } from '@westwing/ui-kit/typography';
import { forDesktop, forIE, forMidWideScreens } from '@westwing/ui-kit/breakPoints';
import MoodboardIcon from '@westwing/ui-kit/Icons/MoodBoardIcon';
import HybridLink from 'Client/components/Generic/Links/HybridLink';

export const Icons = styled.div<{ p100IncreasedDesktopPageWidth?: boolean }>`
    grid-area: icons;
    display: grid;
    grid-template-columns: repeat(2, 40px);
    align-items: center;
    justify-content: space-around;

    padding-top: 6px;
    padding-left: 6px;
    padding-right: 26px;

    ${forDesktop`
        grid-template-columns: 89px 85px 81px;
        grid-template-columns: repeat(4, 1fr);
        align-items: self-start;
        padding: 24px 10px 0 0;
        justify-content: end;
    `}

    ${({ p100IncreasedDesktopPageWidth }) =>
        p100IncreasedDesktopPageWidth &&
        css`
            ${forDesktop`
                padding-right: 0;
                display: flex;
                justify-content: space-between;
            `}
        `}

  ${forIE`
        -ms-grid-row: 2;
        -ms-grid-column: 8;
        -ms-grid-column-span: 1;
        display: flex;
    `}
`;

enum IconScaleFactors {
    small = '1',
    medium = '36/30',
}

export const IconStyles = css`
    height: 36px;
    width: 31px;
    color: ${({ theme }) => theme.colors.charcoal100};
    text-align: center;
    ${forDesktop`
        fill: ${({ theme }) => theme.colors.charcoal100};
        transform: scale(calc(${IconScaleFactors.medium}));
    `}
`;

export const MenuIconWrapper = styled.span`
    position: relative;
    display: inline-block;
    ${IconStyles}
`;

export const MenuLabel = styled.span`
    ${caption1}
    display: none;
    text-align: center;
    color: ${({ theme }) => theme.colors.charcoal100};
    ${forDesktop`
        display: block;
    `}
    ${forMidWideScreens`
        max-width: 75px;
    `}
    ${forIE`
        max-width: 88px;
    `}
`;

export const MenuSubLabel = styled(MenuLabel)`
    ${body2Bold}
    font-size: 12px;
    color: ${({ theme }) => theme.colors.turquoise100};
`;

export const ItemWrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
    ${forIE`
        padding: 0 5px;
    `}
    :hover
        ${MenuLabel} {
        opacity: 0.5;
    }
`;

export const DesktopOnlyItemWrapper = styled(ItemWrapper)`
    display: none;
    ${forDesktop`
        display: flex;
    `}
`;

export const IconItemWrapper = styled.div`
    display: block;
    text-align: center;
    /* width: 30px; */
    ${forDesktop`
        cursor: pointer;
        width: auto;
    `}
`;

export const IconLink = styled(HybridLink)`
    text-align: left;
    display: flex;
    flex-flow: column;
    align-items: center;
`;

export const StyledMoodBoardIcon = styled(MoodboardIcon)`
    margin-top: 3px;
    width: 28px;
`;

export const IconBadge = styled.span`
    ${caption1}
    position: absolute;
    font-size: 8px;
    font-weight: 600;
    color: #9c2232;
    right: -16px;
`;
